import styled from 'styled-components'

export const StyledNewsArticleImages = styled.div`
  .articleImages {
    width: 85%;
    display: flex;
    flex-direction: row;
  }
`
